import React from 'react';
import { useLeaveBalanceList } from './hooks/useLeaveBalanceList';
import SharedFilters from '../../../components/SharedFilters';
import AppPagination from '../../../components/AppPagination';
import LeaveBalanceSummaryCards from './components/LeaveBalanceSummaryCards';
import LeaveBalanceTable from './components/LeaveBalanceTable';

export default function LeaveBalanceListScreen() {
  const { state, actions } = useLeaveBalanceList();

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-12">
      {/* Header Banner */}
      <section className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between border-b border-outline-variant/15 pb-4">
        <div>
          <h1 className="font-display text-4xl font-extrabold leading-[0.98] tracking-[-0.02em] text-on-surface">
            Leave Balance
          </h1>
          <p className="mt-1.5 text-xs text-on-surface-variant font-medium">
            Annual leave quota breakdown, usage history, and current balances
          </p>
        </div>
      </section>

      {/* Summary KPI Cards */}
      <LeaveBalanceSummaryCards summary={state.summary} />

      {/* Shared Filters Component */}
      <SharedFilters
        searchField={state.searchField}
        searchText={state.searchText}
        showStatus={false}

        yearFilter={state.yearFilter}
        yearOptions={state.yearOptions}
        typeFilter={state.leaveTypeFilter}
        typeOptions={state.leaveTypeOptions}

        setSearchField={actions.setSearchField}
        setSearchText={actions.setSearchText}
        setYearFilter={actions.setYearFilter}
        setTypeFilter={actions.setLeaveTypeFilter}

        onSearch={actions.handleSearch}
        onReset={actions.resetFilters}

        searchFieldOptions={state.searchFieldOptions}

        visibleAccordionFilters={[
          'type',
          'year',
        ]}

        tools={state.tools}
        onToolSelect={actions.handleToolSelect}
      />

      {/* Leave Balance Table */}
      <section className="space-y-4">
        <LeaveBalanceTable
          records={state.records}
          isLoading={state.isLoading}
          onApplyLeave={actions.handleApplyLeave}
          onResetFilters={actions.resetFilters}
        />

        {/* Table Footer with Pagination */}
        <div className="flex flex-col items-center justify-between gap-4 border-t border-outline-variant/15 px-6 py-4 sm:flex-row bg-surface-container-lowest rounded-2xl shadow-xs">
          <p className="text-xs text-on-surface-variant font-medium">
            Showing {state.totalCount === 0 ? 0 : (state.page - 1) * state.pageSize + 1} to{' '}
            {Math.min(state.page * state.pageSize, state.totalCount)} of {state.totalCount} entries
          </p>
          <AppPagination
            page={state.page}
            totalPages={state.totalPages}
            onPageChange={actions.setPage}
            onPrevious={() => actions.setPage((p) => Math.max(p - 1, 1))}
            onNext={() => actions.setPage((p) => Math.min(p + 1, state.totalPages))}
            canPrevious={state.page > 1}
            canNext={state.page < state.totalPages}
          />
        </div>
      </section>
    </div>
  );
}
